import { useState } from "react";
import { toast } from "sonner";
import { shopApi } from "@/lib/shopApi";
import { formatApiErrorDetail } from "@/lib/api";

export default function ResendVerification({ email }) {
  const [busy, setBusy] = useState(false);
  const resend = async () => {
    setBusy(true);
    try {
      await shopApi.post("/member/auth/resend-verification", { email });
      toast.success("If your account still needs verifying, a new link is on its way.");
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <button type="button" onClick={resend} disabled={busy} data-testid="resend-verification-button"
      className="mt-4 w-full rounded-lg border border-slate-200 py-2.5 text-sm font-medium text-slate-700 transition-colors hover:border-slate-900 hover:text-slate-900 disabled:opacity-60">
      {busy ? "Sending…" : "Resend verification email"}
    </button>
  );
}
